function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
import { getAllItemSubMenuNames, getItemParentSubMenus } from './utils';
import menuMixin from './mixins/menu';
var __vue_script__ = {
  name: 'Menu',
  isMenuType: true,
  mixins: [menuMixin],
  data: function data() {
    return {
      activeItem: null,
      selectedItems: [],
      openedSubMenus: [],
      descendants: [],
      ancestorSubMenuNames: []
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var isRoot = this.isRoot,
          prefixCls = this.prefixCls,
          theme = this.theme,
          mode = this.mode,
          visible = this.visible;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-root"), isRoot), _defineProperty(_ref, "".concat(prefixCls, "-").concat(theme), true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(mode), true), _defineProperty(_ref, "".concat(prefixCls, "-hidden"), !visible), _ref;
    }
  },
  watch: {
    openKeys: function openKeys(newVal, oldVal) {
      var _this = this;

      if (newVal !== oldVal) {
        this.$nextTick(function () {
          _this.reloadOpenKeys();
        });
      }
    },
    selectedKeys: function selectedKeys(newVal, oldVal) {
      var _this2 = this;

      if (newVal !== oldVal) {
        this.$nextTick(function () {
          _this2.reloadSelectedKeys();
        });
      }
    },
    descendants: function descendants(nVal) {
      if (nVal) {
        if (this.isRoot) {
          this.init();
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.isRoot) {
      this.init();
    }
  },
  methods: {
    updateAncestorSubMenuNames: function updateAncestorSubMenuNames() {
      var selectedItems = this.selectedItems;
      this.ancestorSubMenuNames = getAllItemSubMenuNames(selectedItems);
    },
    setOpenedSubMenus: function setOpenedSubMenus() {
      var subMenus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.openedSubMenus = subMenus;
      this.$emit('open-change', subMenus.map(function (v) {
        return v.eventName;
      }));
    },
    init: function init() {
      var _this3 = this;

      var descendants = this.descendants,
          openKeys = this.openKeys,
          openedSubMenus = this.openedSubMenus,
          selectedKeys = this.selectedKeys,
          selectedItems = this.selectedItems,
          multiple = this.multiple,
          activeKey = this.activeKey,
          updateAncestorSubMenuNames = this.updateAncestorSubMenuNames;
      var openStrKeys = openKeys.map(function (v) {
        return String(v);
      });
      var selectedStrKeys = selectedKeys.map(function (v) {
        return String(v);
      });
      descendants.forEach(function (v) {
        var eventName = String(v.eventName);

        if (openStrKeys.indexOf(eventName) > -1 && openedSubMenus.indexOf(v) === -1) {
          openedSubMenus.push(v);
        }

        if (selectedStrKeys.indexOf(eventName) > -1 && selectedItems.indexOf(v) === -1 && (multiple || selectedItems.length === 0)) {
          selectedItems.push(v);
        }

        if (activeKey && eventName === activeKey) {
          _this3.activeItem = v;
        }
      });
      updateAncestorSubMenuNames();
    },
    addDescendants: function addDescendants(item) {
      var descendants = this.descendants;

      if (descendants.indexOf(item) === -1) {
        descendants.push(item);
      }
    },
    removeDescendants: function removeDescendants(item) {
      var descendants = this.descendants;
      var idx = descendants.indexOf(item);

      if (idx > -1) {
        this.descendants.splice(idx, 1);
      }
    },
    reloadOpenKeys: function reloadOpenKeys() {
      var descendants = this.descendants,
          openKeys = this.openKeys;
      var openedSubMenus = [];
      var openStrKeys = openKeys.map(function (v) {
        return String(v);
      });
      descendants.forEach(function (v) {
        var eventName = String(v.eventName);

        if (openStrKeys.indexOf(eventName) > -1 && openedSubMenus.indexOf(v) === -1) {
          openedSubMenus.push(v);
        }
      });
      this.openedSubMenus = openedSubMenus;
    },
    reloadSelectedKeys: function reloadSelectedKeys() {
      var descendants = this.descendants,
          selectedKeys = this.selectedKeys,
          multiple = this.multiple,
          updateAncestorSubMenuNames = this.updateAncestorSubMenuNames;
      var selectedItems = [];
      this.selectedItems = selectedItems;
      var selectedStrKeys = selectedKeys.map(function (v) {
        return String(v);
      });
      descendants.forEach(function (v) {
        var eventName = String(v.eventName);

        if (selectedStrKeys.indexOf(eventName) > -1 && selectedItems.indexOf(v) === -1 && (multiple || selectedItems.length === 0)) {
          selectedItems.push(v);
        }
      });
      updateAncestorSubMenuNames();
    },
    onMenuActive: function onMenuActive(_ref2) {
      var item = _ref2.item,
          hover = _ref2.hover;
      this.activeItem = hover ? item : null;
    },
    onMenuItemClick: function onMenuItemClick(e) {
      var mode = this.mode,
          setOpenedSubMenus = this.setOpenedSubMenus;
      var item = e.item;

      if (this.descendants.indexOf(item) > -1) {
        this.$emit('click', _objectSpread({}, e, {
          item: _objectSpread({}, item.$attrs, {
            name: item.name,
            label: item.label,
            disabled: item.disabled
          })
        }));
      }

      if (mode !== 'inline') {
        setOpenedSubMenus([]);
      }
    },
    onSubMenuClick: function onSubMenuClick(e) {
      var uniqueOpened = this.uniqueOpened;
      var openedSubMenus = this.openedSubMenus;
      var open = e.open,
          item = e.item;

      if (this.descendants.indexOf(item) > -1) {
        var changed = false;
        var pos = openedSubMenus.indexOf(item);

        if (open) {
          if (pos === -1) {
            // uniqueOpened 只展示当前菜单, 其他菜单收起
            if (uniqueOpened) {
              openedSubMenus = getItemParentSubMenus(item);
            }

            openedSubMenus.push(item);
            changed = true;
          }
        } else if (pos > -1) {
          openedSubMenus.splice(pos, 1);
          changed = true;
        }

        if (changed) {
          this.setOpenedSubMenus(openedSubMenus);
        }
      }
    },
    onMenuItemDeselect: function onMenuItemDeselect(e) {
      var selectedItems = this.selectedItems,
          updateAncestorSubMenuNames = this.updateAncestorSubMenuNames;
      var item = e.item;
      var pos = selectedItems.indexOf(item);

      if (pos > -1) {
        selectedItems.splice(pos, 1);
      } // 直接将vue instance emit出去, vue-devtools(4.0.1)会报错


      this.$emit('deselect', _objectSpread({}, e, {
        item: _objectSpread({}, item.$attrs, {
          name: item.name,
          label: item.label,
          disabled: item.disabled
        }),
        selectedKeys: selectedItems.map(function (v) {
          return v.eventName;
        })
      }));
      updateAncestorSubMenuNames();
    },
    onMenuItemSelect: function onMenuItemSelect(e) {
      var multiple = this.multiple,
          updateAncestorSubMenuNames = this.updateAncestorSubMenuNames;
      var selectedItems = this.selectedItems;
      var item = e.item;
      var pos = selectedItems.indexOf(item);

      if (pos === -1) {
        if (multiple) {
          selectedItems = [].concat(_toConsumableArray(selectedItems), [item]);
        } else {
          selectedItems = [item];
        }
      }

      this.selectedItems = selectedItems;
      this.$emit('select', _objectSpread({}, e, {
        item: _objectSpread({}, item.$attrs, {
          name: item.name,
          label: item.label,
          disabled: item.disabled
        }),
        selectedKeys: selectedItems.map(function (v) {
          return v.eventName;
        })
      }));
      updateAncestorSubMenuNames();
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ul', {
    class: _vm.classes,
    attrs: {
      "role": "menu"
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "menu.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);